import { PulseContentItem } from "plos/src/utils/pulse";
import { newsGrid3fr, newsGrid6fr, newsScrollableRow } from "../news.css";
import { NewsItem } from "../NewsItem";
import { newsListStyles } from "./newsList.css";
import { NewsListProps } from "./types";

const NewsList = ({
  imgSizes,
  imgWidth,
  items,
  layout,
  variant,
}: NewsListProps) => {
  const getLayoutClass = () => {
    switch (layout) {
      case "scrollableRow":
        return newsScrollableRow;
      case "threeColGrid":
        return newsGrid3fr;
      case "sixColGrid":
        return newsGrid6fr;
    }
  };
  return (
    <div className={newsListStyles}>
      <div className={getLayoutClass()}>
        {items
          .filter(
            (item): item is PulseContentItem =>
              item != null && typeof item.id === "number",
          )
          .map((item) => (
            <NewsItem
              imgSizes={imgSizes}
              imgWidth={imgWidth}
              key={item.id}
              news={item}
              variant={variant}
            />
          ))}
      </div>
    </div>
  );
};

export default NewsList;
